import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { LoginComponent } from "./pages/login/login.component";
import { RosterComponent } from "./pages/roster/roster.component";
import { AuthGuard } from "./auth/auth.guard";

const routes: Routes = [
  { path: "", redirectTo: "roster", pathMatch: "full" },
  { component: LoginComponent, path: "login" },
  { component: RosterComponent, path: "roster", canActivate: [AuthGuard] },
  { path: "**", redirectTo: "roster" }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
